import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import { Component, createCommentVNode, createTextVNode, mount, patch, remove, inject, unmount, removeVNodeDom } from 'intact-react';
import { isString } from 'intact-shared';
import { DIALOG } from './dialog/constants';
import { BaseDialog } from './dialog/base';
import { useConfigContext } from './config';
var typeDefs = {
  container: [String, Function]
};
export var Portal = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Portal, _Component);
  function Portal() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.container = null;
    _this.dialog = inject(DIALOG, null);
    _this.mountedQueue = void 0;
    _this.mountedDone = void 0;
    _this.$isPortal = true;
    _this.config = useConfigContext();
    return _this;
  }
  Portal.template = function template() {
    if (process.env.NODE_ENV === 'production') {
      return createTextVNode('');
    }
    return createCommentVNode('portal');
  };
  var _proto = Portal.prototype;
  _proto.$render = function $render(lastVNode, nextVNode, parentDom, anchor, mountedQueue // in React, it has priority property to add some prior functions
  ) {
    var _this2 = this;
    /**
     * In React, we cannot render real elements in mountedQueue.
     * Because the rendering time of react element is uncontrollable
     */
    var nextProps = nextVNode.props;
    var fakeContainer = document.createDocumentFragment();
    (mountedQueue.priority || mountedQueue).push(function () {
      var parentDom = _this2.$lastInput.dom.parentElement;
      // maybe the <!-- portal --> has been removed by react, #938
      if (!parentDom) return;
      _this2.initContainer(nextProps.container, parentDom, anchor);
      _this2.container.appendChild(fakeContainer);
    });
    mount(nextProps.children, fakeContainer, this, this.$SVG, null, mountedQueue);
    _Component.prototype.$render.call(this, lastVNode, nextVNode, parentDom, anchor, mountedQueue);
  };
  _proto.$update = function $update(lastVNode, nextVNode, parentDom, anchor, mountedQueue, force) {
    var _this3 = this;
    // update container if it has changed
    var lastProps = lastVNode.props;
    var nextProps = nextVNode.props;
    var update = function update() {
      var lastContainer = _this3.container;
      if (lastProps.container !== nextProps.container) {
        _this3.initContainer(nextProps.container, parentDom, anchor);
      }
      var nextContainer = _this3.container;
      if (lastContainer === nextContainer) {
        patch(lastProps.children, nextProps.children, nextContainer, _this3, _this3.$SVG, anchor, mountedQueue, false);
      } else {
        remove(lastProps.children, lastContainer, false);
        mount(nextProps.children, nextContainer, _this3, _this3.$SVG, anchor, mountedQueue);
      }
      _Component.prototype.$update.call(_this3, lastVNode, nextVNode, parentDom, anchor, mountedQueue, force);
    };
    if (!this.container) {
      // in react, sometimes $update will be called before mountedQueue in $render
      (mountedQueue.priority || mountedQueue).push(update);
    } else {
      update();
    }
  };
  _proto.$unmount = function $unmount(vNode, nextVNode) {
    var children = vNode.props.children;
    unmount(children, null);
    if (this.container) {
      // maybe the <!-- portal --> has been removed by react, #938
      // remove(children, this.container, false);
      removeVNodeDom(children, this.container);
    }
    _Component.prototype.$unmount.call(this, vNode, nextVNode);
  };
  _proto.initContainer = function initContainer(container, parentDom, anchor) {
    if (container) {
      if (isString(container)) {
        this.container = document.querySelector(container);
      } else {
        this.container = container(parentDom, anchor);
      }
    } else {
      // let below logic to set container to default if container does not exist.
      this.container = null;
    }
    if (!this.container) {
      if (this.$senior instanceof BaseDialog) {
        // Dialog and Drawer must be inserted into document.body
        // this.container = document.body;
        /**
         * @Modify https://github.com/ksc-fe/kpc/issues/915
         * shoud insert to parent .k-dialog-wrapper to show nested dialog in Vue
         */
        this.container = parentDom.closest("." + this.config.k + "-dialog-wrapper") || document.body;
      } else {
        // find the closest dialog if exists
        this.container = parentDom.closest("." + this.config.k + "-dialog") || document.body;
      }
      /**
       * @FIXME: We cannot get parent ref from sub component in Vue
       */
      // find the closest dialog if exists
      // let tmp;
      // if ((tmp = this.dialog) && (tmp !== this.$senior) && (tmp = tmp.dialogRef.value)) {
      // this.container = tmp;
      // } else {
      // this.container = document.body;
      // }
    }
  };
  return Portal;
}(Component);
Portal.typeDefs = typeDefs;